import createVueComponent from '../createVueComponent';

const UserCircle2 = createVueComponent('UserCircle2Icon', [
  ['path', { d: 'M18 20a6 6 0 0 0-12 0', key: '1qehca' }],
  ['circle', { cx: '12', cy: '10', r: '4', key: '1h16sb' }],
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
]);

export default UserCircle2;
